import { useState, useEffect } from 'react';
import { WidgetView } from 'common';
import { getSourceType } from '@src/pages/Widget/utils/sourceType';
import { createChangeSettings } from '../utils/createChangeSettings';

export type WidgetType = 'collection' | 'product';

export const useQuickType = (editedWidget: any, setEditedWidget: any, remoteWidget: WidgetView) => {
  let initialType: WidgetType;
  try {
    initialType = getSourceType(remoteWidget);
  } catch (error) {
    initialType = 'collection';
  }
  const [widgetType, setWidgetType] = useState<WidgetType>(initialType);

  const changeSettings = createChangeSettings(editedWidget, setEditedWidget);

  const handleTypeChange = (type: WidgetType) => {
    setWidgetType(type);

    if (type === 'collection') {
      // When changing to collection type:
      // 1. Remove product_list if exists
      // 2. Initialize an empty collection_list if it doesn't exist
      changeSettings({
        default_sources: {
          collection_list: editedWidget.settings.default_sources?.collection_list || [],
          product_list: undefined,
        },
      });
    } else if (type === 'product') {
      // When changing to product type:
      // 1. Initialize an empty product_list if it doesn't exist
      // 2. Empty the collection_list (product widgets can have collection filters but start empty)
      changeSettings({
        default_sources: {
          collection_list: [], // Empty the collection list when switching to product type
          product_list: editedWidget.settings.default_sources?.product_list || [],
        },
      });
    }
  };

  // Sync with external changes on initial mount
  useEffect(() => {
    try {
      const currentType = getSourceType(remoteWidget);
      setWidgetType(currentType);
    } catch (error) {
      setWidgetType('collection');
    }
  }, []);

  return {
    widgetType,
    handleTypeChange,
    isCollectionType: widgetType === 'collection',
    isProductType: widgetType === 'product',
  };
};
